<template>
    <div >
        <div v-if="LocalCashup" ref="live_body_height">  
            <v-menu 
                v-model="menuSelect" 
                :close-on-content-click="false" 
                offset-y  offset-overflow
                rounded="xl" max-width="500" nudge-width="300"
                >
                <template v-slot:activator="{ on }"> 
                    <!-- <v-card   v-on="on"  -->
                    <v-card   @click="ON_VIEW_CASHUP()"
                        class="py-1"  color="transparent"  outlined
                         min-height="20" rounded="lg" flat >
                        <v-layout fill-height align-center class="ma-0 px-2 pb-1 pt-1 mbs-one-line  "> 
                            <v-card  rounded="" outlined class="ma-1 pa-1"> 
                                <v-layout > 
                                    <div  class="mx-2"> 
                                        <v-badge v-if="CurrentTill?.server" :value="SHOW_OFFLINE" 
                                            bordered
                                            :class="MBS.data.animate.zoom.in"
                                            :color="onlineIndicator" dot
                                            overlap
                                        > 
                                            <span v-if="CurrentTill?.eis_terminal" class="font-weight-bold ">EIS</span>
                                            <v-icon :small="vs.smAndDown" color="primary">
                                                {{ Assistant?mdiInvoiceTextEdit:"mdi-cash-register"}}
                                            </v-icon>
                                        </v-badge>
                                        <span  v-else>
                                            <span v-if="CurrentTill?.eis_terminal" class="font-weight-bold primary--text mr-1">EIS</span>
                                            <v-icon :small="vs.smAndDown" color="primary"  class="mb-1">
                                                {{ Assistant?mdiInvoiceTextEdit:"mdi-cash-register"}}
                                            </v-icon> 
                                        </span>
                                    </div>
                                    <v-divider vertical class="" /> 
                                    <v-layout v-if="tus && vs_t_user" justify-center align-center class="font-weight-bold mx-2">
                                        <!-- <v-icon size="18">mdi-account-outline</v-icon> -->
                                        <small>{{tus_name}}</small>
                                    </v-layout> 
                                    <v-divider vertical  /> 
                                    <v-layout justify-center align-center class="mx-2" v-if="vs_live_timer" > 
                                        <div class="font-weight-bold not-f3 grey--text text--darken-1">
                                            {{LiveLocalCashup?LiveLocalCashup:'.'}} 
                                        </div>  
                                    </v-layout> 
                                    <v-icon class="mr-1">arrow_drop_down</v-icon>
                                </v-layout>
                            </v-card>
                            
                        </v-layout>  
                    </v-card> 
                </template> 
    
                <v-card  v-if="ud && menuSelect"  
                    color="lighten-1" class="">  
    
                    <!-- //HEADER -->
                    <v-card-title class="secondary white--text" dark >
                        <v-list-item  dark> 
                            <v-list-item-icon><v-icon>mdi-cash-register</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{Joined_LocalCashup?Joined_LocalCashup.outlet_name:'..'}}</v-list-item-title>
                                <v-list-item-subtitle>Till: {{Joined_LocalCashup?Joined_LocalCashup.till_name:'..'}}</v-list-item-subtitle>  
                                <v-list-item-subtitle>Teller: {{Joined_LocalCashup?Joined_LocalCashup.teller_name:'..'}}</v-list-item-subtitle>  
                                <v-list-item-subtitle>Day Shift: <strong>{{CurrentDayShift?.operating_date}}</strong></v-list-item-subtitle>  
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn dark outlined>
                                    {{LiveLocalCashup?LiveLocalCashup:'.'}}
                                </v-btn>
                            </v-list-item-action>
                            <v-list-item-action><v-btn icon="" @click="menuSelect=false"><v-icon>close</v-icon></v-btn></v-list-item-action>
                        </v-list-item>
                    </v-card-title> 
                    <!-- //BODY -->  
                    <!-- <v-list ref="body_height" dense :max-height="vsb.scroll?vsh-175:''" :class="vsb.scroll?'mbs-scroll-y':''"> -->
                    <v-list ref="body_height" dense :max-height="vsh-175" :class="'mbs-scroll-y'">
                        <v-card outlined class="my-2 mx-3" v-if="CurrentTill?.eis_terminal">
                            <div class="text-center font-weight-bold mt-1">EIS</div>
                            <v-divider></v-divider>
                            <v-list-item > 
                                <v-list-item-content>
                                    <div>Transaction Age Hour:</div>
                                    <div>Cumulative Amount :</div> 
                                    <div>Current Offline Amount:</div> 
                                    <div>Last Sync:</div> 
                                    <div>Ping Time:</div> 
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>{{ESI_TerminalConfiguration?.terminalConfiguration?.offlineLimit?.maxTransactionAgeInHours}}Hrs</div>
                                    <div>{{MBS.actions.money(ESI_TerminalConfiguration?.terminalConfiguration?.offlineLimit?.maxCummulativeAmount)}}</div> 
                                    <div>{{MBS.actions.money(TOTAL_PAID_AMOUNT(EIS_not_uploadedOrders))}}</div> 
                                    <div>{{MBS.actions.toDateTime(ESI_TerminalConfiguration?.last_sync)}}</div> 
                                    <div>{{MBS.actions.toDateTime(CurrentTill?.eis_terminal?.ping_server?.serverDate)}}</div> 
                                </v-list-item-action>
                            </v-list-item>  
                            <v-layout row>
                                
                                <v-flex xs6> 
                                    <v-btn class="mr-1" @click="ON_PING_SERVER"  color="primary" small width="99%">Ping Server</v-btn>
                                </v-flex>
                                <v-flex xs6> 
                                    <v-btn @click="ON_SYNC_TERMINAL"  color="primary" small width="100%">Sync EIS Terminal</v-btn>
                                </v-flex>
                            </v-layout>
                            
                        </v-card>
                        <!-- <v-list-item >
                            <v-list-item-action><v-icon >mdi-cash-register</v-icon></v-list-item-action>
                            <v-list-item-content>
                                <div>Outlet:</div>
                                <div>Till:</div> 
                                <div>Teller:</div> 
                            </v-list-item-content>
                            <v-list-item-action>
                                <div>{{Joined_LocalCashup?Joined_LocalCashup.outlet_name:'..'}}</div>
                                <div>{{Joined_LocalCashup?Joined_LocalCashup.till_name:'..'}}</div> 
                                <div>{{Joined_LocalCashup?Joined_LocalCashup.teller_name:'..'}}</div> 
                            </v-list-item-action>
                        </v-list-item>   -->
                        
                        <v-list-item  >
                            <v-list-item-action><v-icon>mdi-receipt</v-icon></v-list-item-action>
                            <v-list-item-content>
                                <div>Uploaded:</div> 
                                <div>Pending:</div> 
                                <div>EIS Submitted:</div>
                                <div class="font-weight-bold not-f3">TOTAL TRANSACTIONS:</div>
                            </v-list-item-content>
                            <v-list-item-action>  
                                <div>{{MBS.actions.SIZE(uploaded_localOrders)}}</div>  
                                <div>{{MBS.actions.SIZE(not_uploaded_localOrders)}}</div>  
                                <div>{{MBS.actions.SIZE(EIS_uploadedOrders)}}</div>  
                                <div class="font-weight-bold not-f3">{{MBS.actions.SIZE(AllLocalSaleOrdersData)}}</div>  
                            </v-list-item-action>
                        </v-list-item>  
                        
                        <!-- //SALES DETAILS -->
                        <v-list-item  v-if="!Assistant">
                            <v-list-item-action><v-icon>mdi-cart</v-icon></v-list-item-action>
                            <v-list-item-content>
                                <div v-for="(tier,index) in OrdersPricingTiers">
                                    {{tier.name}}: <small>{{tier.quantity?.toFixed(2)}} item(s)</small>
                                </div> 
                            </v-list-item-content>
                            <v-list-item-action>
                                <div v-for="(tier,index) in OrdersPricingTiers">
                                    {{MBS.actions.money(tier.sum_amount)}} 
                                </div>  
                            </v-list-item-action>
                        </v-list-item> 
    
                        
                        <!-- //CARDS -->
                        <v-list-item v-if="false">
                            <v-list-item-action><v-icon>{{mdiAccountCreditCard}}</v-icon></v-list-item-action>
                            <v-list-item-content> 
                                <div>Cash Card Load: {{MBS.actions.SIZE(CashCardMoneyLoadOrders)}} Transaction (s)</div> 
                                <div>Other Card Load: {{MBS.actions.SIZE(OtherOptionCardMoneyLoadOrders)}} Transaction (s)</div> 
                                <div>Total Card Load: {{MBS.actions.SIZE(CardMoneyLoadOrders)}} Transaction (s)</div> 
                            </v-list-item-content>
                            <v-list-item-action>
                                <div>{{MBS.actions.money(TOTAL_PAID_AMOUNT(CashCardMoneyLoadOrders))}}</div>
                                <div>{{MBS.actions.money(TOTAL_PAID_AMOUNT(OtherOptionCardMoneyLoadOrders))}}</div>    
                                <div>{{MBS.actions.money(TOTAL_PAID_AMOUNT(CardMoneyLoadOrders))}}</div>    
                            </v-list-item-action>
                        </v-list-item> 
                        
                        <!-- //INVOICES -->
                        <v-list-item  v-if="!Assistant">
                            <v-list-item-action><v-icon>mdi-cash-clock</v-icon></v-list-item-action>
                            <v-list-item-content>  
                                <div>Paid Invoices (Cash): <small>{{MBS.actions.SIZE(CashInvoicePayments)}} Invoice(s)</small></div>  
                                <div>Paid Invoices (Other): <small>{{MBS.actions.SIZE(OtherInvoicePayments)}} Invoice(s)</small></div>  
                            </v-list-item-content>
                            <v-list-item-action> 
                                <div>{{MBS.actions.money(TOTAL_AMOUNT(CashInvoicePayments))}}</div>   
                                <div>{{MBS.actions.money(TOTAL_AMOUNT(OtherInvoicePayments))}}</div>   
                            </v-list-item-action>
                        </v-list-item>  
                        
                       
                        <!-- //SALES -->
                        <v-list-item  v-if="!Assistant" >
                            <v-list-item-action><v-icon>shopping_basket</v-icon></v-list-item-action>
                            <v-list-item-content> 
                                <div>Cash Sales:</div> 
                                <div>Other Sales (Banks):</div>  
                                <div>Credit Sales (On Account):</div> 
                            </v-list-item-content>
                            <v-list-item-action> 
                                <div>{{MBS.actions.money(TOTAL_SOLD(CashOrdersItems)+InputCashPayments)}}</div>
                                <div>{{MBS.actions.money(TOTAL_SOLD(OtherOptionPaymentsOrdersItems)+InputOtherPayments)}}</div>  
                                <div>{{MBS.actions.money(TOTAL_SOLD(OnAccountOrdersItems))}}</div>  
                            </v-list-item-action>
                        </v-list-item>  
                        
                        <!-- //EXPENSES -->
                        <v-list-item  v-if="!Assistant" >
                            <v-list-item-action><v-icon>$money-check-dollar</v-icon></v-list-item-action>
                            <v-list-item-content> 
                                <div>Cash Expenses:</div>  
                                <div>Other Expenses:</div>  
                                <div class="font-weight-bold not-f3">TOTAL EXPENSES:</div>  
                            </v-list-item-content>
                            <v-list-item-action>  
                                <div>{{MBS.actions.money(TOTAL_EXPENSES(CashExpenses))}}</div>  
                                <div>{{MBS.actions.money(TOTAL_EXPENSES(OtherExpenses))}}</div>  
                                <div class="font-weight-bold not-f3">{{MBS.actions.money(TOTAL_EXPENSES(CashupExpenses))}}</div>  
                            </v-list-item-action>
                        </v-list-item>   

                        <!-- //TOTAL SALES -->
                        <v-list-item v-if="!Assistant"  class="font-weight-bold grey--text text--darken-2"> 
                            <v-list-item-content> 
                                <div class="not-f" >TOTAL SALES:</div>  
                                <div class="not-f">CURRENT CASH:</div> 
                            </v-list-item-content>
                            <v-list-item-action> 
                                <div>{{MBS.actions.money(TOTAL_SOLD(OrdersItems))}}</div>   
                                <div class="not-f">{{MBS.actions.money(
                                    TOTAL_SOLD(CashOrdersItems) 
                                    +InputCashPayments
                                    +TOTAL_AMOUNT(CashInvoicePayments)
                                    +toNumber(Joined_LocalCashup.opening_cash)
                                    +TOTAL_PAID_AMOUNT(CashCardMoneyLoadOrders)
                                    -TOTAL_EXPENSES(CashExpenses)
                                )}}</div> 
                            </v-list-item-action>
                        </v-list-item>   
                    </v-list>  
                    
                    <v-divider></v-divider> 
                    <!-- //FOOTER  -->
                    <v-card-actions class="pa-0">
                        <v-btn @click="ON_CLOSE_REGISTER()" text height="50" width="100%" color="secondary">Close Register</v-btn>
                    </v-card-actions>
                    <!-- //FOOTER  -->
                    <!-- <v-card-actions class="pa-0">
                        <v-btn @click="ON_TEST()" text height="50" width="100%" color="secondary">Test</v-btn>
                    </v-card-actions> -->
                </v-card>  
            </v-menu>   
        </div>  
        <div>
            <!-- CONFIRM PASSWORD BEFORE CLOSING -->
            <v-dialog
                v-model="dialog_confirm_before_closing"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="700px"
                transition="dialog-transition" >
                <v-card rounded="lg" v-if="dialog_confirm_before_closing" > 
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text"> 
                            <span >CLOSE REGISTER</span> 
                        </div> 
                        <v-spacer></v-spacer> 
                        <v-btn class="ml-9" @click="dialog_confirm_before_closing=false" icon dark><v-icon >close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <br> 
                        <v-layout   justify-center> 
                            <v-icon size="150">$printer-pos-pause</v-icon>
                        </v-layout>
                        <form @submit.prevent="CONFIRM_BEFORE_CLOSING(input.password)"> 
                            <v-layout row wrap class="mx-0 my-6"  > 
                                <v-flex xs12 >
                                    <div class="mb-2 ml-">Enter your password to confirm closing this register</div>
                                    <v-text-field required prepend-inner-icon="lock"
                                        v-model="input.password"
                                        filled outlined
                                        label="" autofocus clearable
                                        type="password" autocomplete="one-time-code"  
                                        hint="0.00" class="mr-1"  />  
                                </v-flex> 
                                <v-flex xs12   class="my-3">
                                    <v-layout row wrap class="ma-0 pr-1">
                                        
                                        <v-btn   @click="CONFIRM_FORCE_CLOSING_REGISTER()"
                                            :loading="inputLoading" class="mr-2"
                                            color="error" height="50"  >
                                            <div class="not-f5">FORCE CLOSING</div>
                                        </v-btn> 
                                        <v-flex  >
                                            <v-btn   
                                                type="submit"   
                                                :loading="inputLoading"
                                                color="secondary" height="50" width="100%" >
                                                <div class="not-f5">
                                                    <!-- <v-icon class="pr-1 pb-1">mdi-paperclip-plus</v-icon> -->
                                                    CONFIRM PASSWORD
                                                </div>
                                            </v-btn>      
                                        </v-flex>    
                                    </v-layout>
                                </v-flex> 
                            </v-layout>  
                        </form>
                    </v-card-text>  
                </v-card> 
            </v-dialog> 

            <!-- OPEN DRAWER BEFORE CLOSE REGISTER -->
            <v-dialog
                v-model="dialog_drawer_close_register"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="800px"
                transition="dialog-transition" >
                <v-card rounded="lg">
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text">CLOSE THIS REGISTER</div> 
                        <v-spacer></v-spacer>
                        <!-- <div class="font-weight-bold b2--text not-f7">Expect: mwk {{MBS.actions.money(input.expected_cash)}} </div> -->
                        <v-btn dark icon class="ml-5" @click="dialog_drawer_close_register=false" ><v-icon>close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <br> 
                        <form @submit.prevent=" ">
                            <div class="ma-5" v-if="dialog_drawer_close_register">
                                <mbs-input-fields 
                                    v-model="input"
                                    :disabled_fields="DisabledCashupFields"
                                    :field_items="DATA.FIELDS.close_cashups"
                                    :select_items="SelectInputFieldsItems"  
                                    />    
                                <v-layout class="ma-0 mt-5">
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn text large color="primary" @click="dialog_drawer_close_register = false">Not now</v-btn> -->
                                    <v-btn :loading="inputLoading" type="" large color="primary">Close Register</v-btn>
                                </v-layout>
                            </div> 
                        </form>
                    </v-card-text> 
                </v-card> 
            </v-dialog> 

             <!-- DRAWER BEFORE CLOSING -->
            <v-dialog
                v-model="dialog_open_drawer_before_closing_register"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="700px"
                transition="dialog-transition" >
                <v-card rounded="lg" v-if="dialog_open_drawer_before_closing_register" > 
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text"> 
                            <span >CASHUP BEFORE CLOSING</span> 
                        </div> 
                        <v-spacer></v-spacer> 
                        <v-btn class="ml-9" @click="dialog_open_drawer_before_closing_register=false" icon dark><v-icon >close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <br> 
                        <v-layout   justify-center> 
                            <v-btn :loading="inputLoading" icon class="my-9" @click="OPEN_DRAWER()">
                                <v-icon size="150">mdi-archive-arrow-down-outline</v-icon> 
                            </v-btn>
                        </v-layout>
                        <form @submit.prevent="CONFIRM_CLOSING_REGISTER()"> 
                            <v-layout row wrap class="mx-0 my-6"  > 
                                <v-flex xs12 >
                                    <div class="mb-2 ml-3">
                                        You must count cash before closing Register. This helps monitor the flow of cash. 
                                    </div> 
                                </v-flex> 
                                <v-layout >
                                    <v-card outlined >
                                        <v-simple-table  fixed-header   >
                                            <template v-slot:default>
                                                <thead class="mbs-one-line" > 
                                                    <tr >
                                                        <th class="text-uppercase primary--text b2">
                                                        </th>
                                                        <th class="text-uppercase black--text center-text b2 " > 
                                                            Notes/Coins (CASH) 
                                                        </th>
                                                        <th class="text-uppercase text-center black--text b2">
                                                            QTY (No.)
                                                        </th>
                                                        <th class="text-uppercase text-center black--text b2 ">
                                                            AMOUNT (MWK)
                                                        </th>  
                                                    </tr>  
                                                    <br>
                                                </thead>
                                                <tbody class="mt-5">
                                                    <tr class="mt-5"
                                                        v-for="(item,index) in currency_list"
                                                        :key="index" >
                                                        
                                                        <td> 
                                                            
                                                        </td>
                                                        <td class="text-right"> 
                                                            {{item.name}}
                                                        </td>
                                                        <td class="text-center pa-0"> 
                                                            <v-text-field   full-width
                                                                :required="false"
                                                                prepend-inner-icon="mdi-pound"
                                                                v-model="item.quantity"
                                                                filled  outlined  v-mask="currencyMask"
                                                                label=""  
                                                                type=""
                                                                hint=""   />  
                                                        </td>
                                                        <td class="pa">
                                                            <v-text-field disabled prepend-inner-icon="mdi-cash-multiple" 
                                                                filled outlined  :value="MBS.actions.money(toNumber(item.value )* toNumber(item.quantity))"
                                                                label=""   
                                                                class="mr-1"  />   
                                                        </td>  
                                                    </tr>
                                                    <br>
                                                    <tr > 
                                                        <td class="b1 darken-1">  
                                                        </td>
                                                        <td class="text-right b1 darken-1"> 
                                                            
                                                        </td>
                                                        <td class="text-center  font-weight-bold b1 darken-1">
                                                            TOTAL AMOUNT
                                                        </td>
                                                        <td class="text-center font-weight-bold b1 darken-2">
                                                            {{ MBS.actions.money(TotalCurrency) }}
                                                        </td>  
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table> 
                                    </v-card> 
                                </v-layout>
                                <v-flex xs12   class="my-3">
                                    <v-layout row wrap class="ma-0 pr-1">
                                        
                                        <v-btn   @click="dialog_open_drawer_before_closing_register=false"
                                            :loading="inputLoading" class="mr-2"
                                            color="primary" height="50"  >
                                            <div class="not-f5">CANCEL</div>
                                        </v-btn> 
                                        <v-flex  >
                                            <v-btn   
                                                type="submit"   
                                                :loading="inputLoading"
                                                color="secondary" height="50" width="100%" >
                                                <div class="not-f5">
                                                    <v-icon size="35" class="pr-1 pb-1">$printer-pos-pause</v-icon>
                                                    CLOSE REGISTER
                                                </div>
                                            </v-btn>      
                                        </v-flex>    
                                    </v-layout>
                                </v-flex> 
                            </v-layout>  
                        </form>
                    </v-card-text>  
                </v-card> 
            </v-dialog> 

            <!-- //print -->
            <div v-if="auto_print.printing"> 
                <mbs-auto-print 
                    @finish_print="FINISH_PRINT"
                    :show="true"  
                    :auto_print="auto_print.auto"
                    :auto_printer_name="auto_print.auto_printer_name"
                    :com_printer="auto_print.com_printer"  
                    :data="auto_print.print_data"
                    :type="auto_print.print_type"
                    :title="auto_print.print_title"
                    :printing_action="auto_print.printing_action"
                    :display_option="auto_print.display_option" 
                    />  
            </div>  

             <!-- RECEIVE JOIN ASSISTANT REQUEST -->
            <v-dialog
                :value="dialog_receive_join_assistant_request"
                scrollable   
                :persistent="true" :overlay="false"
                max-width="800px"
                transition="dialog-transition" >
                <v-card :rounded="false">
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text"> 
                            JOINING REQUEST 
                            <span class="secondary--text ml-4">( Request No. {{CASHUP_REQUEST_DATA?.mkey}} )</span>
                        </div>   
                        <v-spacer /> 
                        <div v-if="SHOW_OFFLINE" > 
                            <v-avatar  
                                size="22" style="border: 1px solid white !important; "
                                :color="onlineLan?'green':'red'" 
                                :class="MBS.data.animate.zoom.in"
                                class=""  >  
                            </v-avatar>  
                        </div>
                    </v-card-title>
                    <v-card-text> 
                        <form @submit.prevent="">
                            <v-layout  justify-center algn-center class="mb-5 mt-3">
                                <v-icon size="150" >mdi-lan-connect</v-icon>
                            </v-layout>
                            <v-card outlined class="mbs-scroll-y" :height="vsh-600" :min-height="170" max-height="400" v-if="AssistantTill">
                                <!-- //User -->
                                <v-list class="mx-2">
                                    <v-list-item dense @click="" >
                                        <v-list-item-action > 
                                            <v-avatar    
                                                size="40" rounded 
                                                color="b2" class="white--text" >
                                                <!-- <v-icon v-if="AssistantTill.running">$printer-pos-play</v-icon>
                                                <v-icon v-else>$printer-pos-pause</v-icon> -->
                                                <v-icon>mdi-cash-register</v-icon>
                                            </v-avatar>   
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title >
                                                <v-avatar class="mb-1"
                                                    size="10"  
                                                    :color="AssistantTill.online?'green':AssistantTill.closed?'orange':'red'" > 
                                                </v-avatar>
                                                {{AssistantTill.name}}  
                                                <span class="ml-5 font-weight-bold">({{ MBS.actions.TEXT_UP1(AssistantTill.till_type_key) }})</span>
                                            </v-list-item-title> 
                                            <v-list-item-subtitle  >
                                                Teller: {{AssistantTeller?AssistantTeller.names:'--' }} {{AssistantTeller?AssistantTeller.surname:'--' }} <strong class="mx-3" >|</strong> <strong>{{ AssistantTill.status }}</strong>
                                            </v-list-item-subtitle> 
                                        </v-list-item-content>
                                        <!-- <v-list-item-action> 
                                            <v-btn class="px-4" dark color="secondary" rounded  :loading="inputLoading" 
                                                @click="SEND_CASHUP_JOIN_REQUEST({key:CASHUP_REQUEST_DATA?.key,description:input?input.description:null},true)" 
                                                small>Notify <v-icon class="ml-3" >mdi-bell-ring</v-icon></v-btn>    
                                        </v-list-item-action> -->
                                    </v-list-item>   
                                </v-list>
                                <v-divider></v-divider>
                                <!-- //fields -->
                                <!-- <div class="ma-5" v-if="ASSISTANT_START_SELLING_DATA"> 
                                    <mbs-input-fields 
                                        v-model="input"
                                        :field_items="DATA.FIELDS.description"
                                        :select_items="DataSource"  
                                        />   
                                </div>   -->
                                <v-card-text>
                                    <span v-if="CASHUP_REQUEST_DATA?.description">
                                        Message: 
                                        {{CASHUP_REQUEST_DATA?.description }} 
                                    </span>
                                    <span>No message</span>
                                </v-card-text>
                            </v-card>
                            <v-layout class="ma-0 mt-5">
                                <v-btn @click="REJECT_ASSISTANT_JOIN_REQUEST()" type="" large color="primary" class="px-5 mr-1">REJECT ASSISTANT</v-btn>
                                <v-flex  >  
                                    <v-btn @click="APPROVE_ASSISTANT_JOIN_REQUEST()" width="100%" type="" large color="secondary">APPROVE REQUEST</v-btn>
                                </v-flex> 
                            </v-layout>
                        </form>
                    </v-card-text> 
                </v-card> 
            </v-dialog> 
        </div>
    </div>
</template> 
<script>
let PAGE_NAME = 'LIVE-TILL'
import DATA from "../../plugins/DATA"
import DB from "../../plugins/db/localDB"
import {mapState } from "vuex"
import { mdiAccountCreditCard } from '@mdi/js';
import { mdiInvoiceTextEdit } from '@mdi/js';
import { toNumber } from '../../plugins/formatNumber'
export default { 
    data(){
        return{  
            body_height:0,
            dialog:false,  
            input:{}, 
            menuSelect:false,
            dialog_drawer_close_register:false, 
            dialog_open_drawer_before_closing_register:false, 
            dialog_confirm_before_closing:false, 
            dialog_receive_join_assistant_request:false, 
            DATA:DATA, 
            mdiAccountCreditCard:mdiAccountCreditCard, 
            mdiInvoiceTextEdit:mdiInvoiceTextEdit, 
            currency_list:[
                {value:1,name:"1.00",icon:"mdi-cash"},
                {value:5,name:"5.00",icon:"mdi-cash"},
                {value:10,name:"10.00",icon:"mdi-cash"},
                {value:20,name:"20.00",icon:"mdi-cash"},
                {value:50,name:"50.00",icon:"mdi-cash"},
                {value:100,name:"100.00",icon:"mdi-cash"},
                {value:200,name:"200.00",icon:"mdi-cash"},
                {value:500,name:"500.00",icon:"mdi-cash"},
                {value:1000,name:"1,000.00",icon:"mdi-cash"},
                {value:2000,name:"2,000.00",icon:"mdi-cash"},
                {value:5000,name:"5,000.00",icon:"mdi-cash"},
            ], 

            auto_print:{
                auto:false,
                printing:false, 
                print_data:null,
                print_type:null,
                com_printer:false, 
                print_title:null, 
                auto_printer_name:null,
                printing_action:null, 
                display_option:'',  
            },
            CASHUP_REQUEST_DATA:null,
            closing_us:null
            
        } 
    }, 
    created() {
        try {
            this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            this.MBS.events.$on('ON_CLOSE_REGISTER', this.ON_CLOSE_REGISTER);  
            this.MBS.events.$on('ON_LAN', this.ON_LAN);   
            this.MBS.events.$on('SYNC_EIS_PRODUCTS', this.SYNC_EIS_PRODUCTS);   
            this.MBS.events.$on('GET_LATEST_CONFIGURATION', this.GET_LATEST_CONFIGURATION);   
            this.MBS.events.$on('PING_SERVER', this.PING_SERVER);   
            this.MBS.events.$on('EIS_CHECK_BLOCK_STATUS', this.EIS_CHECK_BLOCK_STATUS);   
            
        } catch (error) {
            this.MBS.actions.error({
                error:error,
                from:'created',
                page:PAGE_NAME, 
            }) 
        }
    },
    mounted(){ 
        this.input={}
        this.inputLoading=false   
        this.COMPANY_QUICK_ACTIONS(this.CompanyQuickActions)
        this.CHECK_TILL(this.Joined_LocalCashup)
        this.FI_INITIATE()
    },
    computed:{
        route(){
            return this.$route
        },
        vs(){

            console.log(this.$vuetify.breakpoint,'this.$vuetify.breakpoint..............');
            
            return this.$vuetify.breakpoint
        }, 
        vsh(){ 
            return this.vs.height
        }, 
        vsw(){ 
            return this.vs.width
        },  
        vsb(){ 
            let body_height = this.body_height 
            let height = this.vs.height 
            body_height = this.$refs.body_height?this.$refs.body_height.$el.clientHeight:body_height;
            let diff = height-body_height
            let scroll = {
                height:height,
                body_height:body_height,
                diff:diff,
                scroll:body_height?diff>180?false:true:false,
            }
            console.log(scroll,'sssssss....-....');
            console.log(this.$refs,'this.$refs.body_height...-.....');
            
            return scroll
        },
        vs_live_timer(){ 
            const vsw = this.vsw
            let show = false
            if (vsw>600) {
                show = true
            } 
            return show
        }, 
        vs_t_user(){ 
            const vs = this.vs
            const vsw = this.vsw
            let show = false
            if (vsw>700) {
                show = true
            } 
            // console.log(vs,vsw,' ........w'); 
            return show
        }, 
        tus_name(){
            const names = this.tus?.names
            const surname = this.tus?.surname
            return surname+" "+names
        },
        onlineIndicator(){
            const online = this.online
            const onlineLan = this.onlineLan
            let light = "green"
            if (!online) {
                light = "red"
            } else if (!onlineLan) {
                light = "orange"
            } else {
                
            }
            return light
        },
        onlineLan(){   
            const LAN = this.LAN
            const current_server = this.CurrentServer
            const api_link = (current_server?.api_link || '').trim(); 
            const online = LAN?.[api_link]  
            return online
        },
        ...mapState({
            loading:state=>state.load.loading,
            processes:state=>state.load.processes,
            responses:state=>state.load.responses,
        }),
        ...mapState({
            us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
            ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()], 
            tus: state=> state.users["TEMPORARY_USER"], 
            SelectedCompany: state=> state.items["SELECTED_COMPANY"],  
            SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
            SHOW_OFFLINE: state=> state.items['SHOW_OFFLINE'],
            online: state=> state.users['ONLINE_STATUS'],
            SERVERS: state=> state.lan['SERVERS'],
            LAN: state=> state.lan['LAN'],
            EVENTS: state=> state.lan['EVENTS'],
            SAGE_LOADER: state=> state.lan['SAGE_LOADER'],
            SERVER_INFO: state=> state.lan['SERVER_INFO'],
        }),
        ...mapState({
            CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
            CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
            Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
            JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
            ItemOrders: state=> state.items[(DATA.ITEMS.ITEM_ORDERS.values).toUpperCase()],
            JoinedItemOrders: state=> state.join[(DATA.ITEMS.ITEM_ORDERS.values).toUpperCase()],
            LocalItemOrders: state=> state.items[(DATA.ITEMS.LOCAL_ITEM_ORDERS.values).toUpperCase()],
            JoinedLocalItemOrders: state=> state.join[(DATA.ITEMS.LOCAL_ITEM_ORDERS.values).toUpperCase()],
            Expenses: state=> state.items[(DATA.ITEMS.EXPENSES.values).toUpperCase()],
            JoinedExpenses: state=> state.join[(DATA.ITEMS.EXPENSES.values).toUpperCase()], 

            
            Payments: state=> state.items[(DATA.ITEMS.PAYMENTS.values).toUpperCase()],
            JoinedPayments: state=> state.join[(DATA.ITEMS.PAYMENTS.values).toUpperCase()], 
            PaidInvoices: state=> state.items[(DATA.ITEMS.PAID_INVOICES.values).toUpperCase()],
            JoinedPaidInvoices: state=> state.join[(DATA.ITEMS.PAID_INVOICES.values).toUpperCase()], 
            SaleOrders: state=> state.items[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()],
            JoinedSaleOrders: state=> state.join[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()],  
            LocalSaleOrders: state=> state.items[(DATA.ITEMS.LOCAL_SALE_ORDERS.values).toUpperCase()],
            JoinedLocalSaleOrders: state=> state.join[(DATA.ITEMS.LOCAL_SALE_ORDERS.values).toUpperCase()],
            JoinedLocalCashups: state=> state.join[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
            Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
            JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()],  
            LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],

            PricingTiers: state=> state.items[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
            JoinedPricingTiers: state=> state.join[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
            DefaultPricingTiers: state=> state.app['DEFAULT_PRICING_TIERS'], 
        
            DaySales: state=> state.items[(DATA.ITEMS.DAY_SALES.values).toUpperCase()],
            JoinedDaySales: state=> state.join[(DATA.ITEMS.DAY_SALES.values).toUpperCase()],  
            DayOrders: state=> state.items[(DATA.ITEMS.DAY_ORDERS.values).toUpperCase()],
            JoinedDayOrders: state=> state.join[(DATA.ITEMS.DAY_ORDERS.values).toUpperCase()], 
            Devices: state=> state.items[(DATA.ITEMS.DEVICES.values).toUpperCase()],
            JoinedDevices: state=> state.join[(DATA.ITEMS.DEVICES.values).toUpperCase()],    
        }),
        DaySalesData(){ 
            let cashup = this.cashup
            let cashup_key = cashup?cashup.key:null
            let DaySales = this.DaySales
            let JoinedDaySales = this.JoinedDaySales
            let items = JoinedDaySales?JoinedDaySales:DaySales  
            if(!items){return null}
            let list = [...items] 
            let filtered = list.filter(item=>{
                return item.cashup_key+"" == cashup_key+""
            }) 
            return cashup_key?filtered:list
        }, 
        DayOrdersData(){ 
            let cashup = this.cashup
            let cashup_key = cashup?cashup.key:null
            let DayOrders = this.DayOrders
            let JoinedDayOrders = this.JoinedDayOrders
            let items = JoinedDayOrders?JoinedDayOrders:DayOrders  
            if(!items){return null}
            let list = [...items] 
            let filtered = list.filter(item=>{
                return item.cashup_key+"" == cashup_key+""
            }) 
            return cashup_key?filtered:list
        }, 
        ExpensesData(){
            let items = this.JoinedExpenses?this.JoinedExpenses:this.Expenses 
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("created_at_server",false))   
            list.sort(this.MBS.actions.dynamicSort("expense_date",false))  
            
            console.log(list,'list+++++++++++++++');
            
            return list 
        },
        DevicesDataItems(){
            return this.JoinedDevices?this.JoinedDevices:this.Devices
        },
        findServer(){
                let devices = this.DevicesDataItems
                return (code)=>devices?.find(item=>item.code == code)
            },
        CashupExpenses(){
            const expenses = this.ExpensesData
            const cashup = this.LocalCashup 
            if(!expenses){return null}
            const filter = expenses.filter(item=>item.cashup_key == cashup?.key)
            return filter
        },
        CashExpenses(){
            const expenses = this.CashupExpenses
            if(!expenses){return null}
            const filter = expenses.filter(item=>item.payment_method_key == "cash")
            return filter
        },
        OtherExpenses(){
            const expenses = this.CashupExpenses
            if(!expenses){return null}
            const filter = expenses.filter(item=>item.payment_method_key != "cash")
            return filter
        },
        OtherExpensesAccounts(){
            const expenses = this.CashupExpenses
            if(!expenses){return null}
            let accounts = []
            expenses.forEach(expense => {
                const index = accounts.findIndex(item=> item.expense_account_code == expense.expense_account_code)
                if (index==-1) {
                    accounts.push({
                        expense_account_code : expense.expense_account_code,
                        expense_account_name : expense.expense_account_name,
                        amount : this.toNumber(expense.amount),
                    }) 
                } else {
                    accounts[index].amount=accounts[index].amount+this.toNumber(expense.amount) 
                }
            });
             
            return accounts
        },


        PricingTiersData(){
            return this.JoinedPricingTiers?this.JoinedPricingTiers:this.PricingTiers
        }, 
        AllPricingTiers(){
            let defaults = this.DefaultPricingTiers
            let tiers = this.PricingTiersData 
            let all = []
            if (defaults) {
                all.push(...defaults)
            }if (tiers) {
                tiers.forEach(tier => {
                    let index = all.findIndex(item=>item.key == tier.key)
                    if (index==-1) {
                        all.push(tier) 
                    } else {
                        all[index] = {
                            ...all[index],
                            ...tier
                        }
                    }
                });
            }
            return all
        }, 
        ItemOrdersData(){    
            return this.JoinedItemOrders?this.JoinedItemOrders:this.ItemOrders
        },  
        LocalItemOrdersData(){  
            return this.JoinedLocalItemOrders?this.JoinedLocalItemOrders:this.LocalItemOrders
        },
        LiveLocalItemOrder(){  
            const local = this.LocalItemOrdersData
            const live = this.ItemOrdersData   
            console.log(local,'local--------------***');
            console.log(live,'live--------------***');
            
            const find = key=>{
                if(!live){return null}
                return live.find(order=>order.key == key)
            } 
            let items = []
            if (this.MBS.actions.SIZE(live)>0) {
                items.push(...live)
            }
            if (this.MBS.actions.SIZE(local)>0) {
                local.forEach(element => {
                    // let uploaded_order = find(element.key)
                    const order_index =items.findIndex(order=>order.key == element.key)
                    if (order_index==-1) {
                        items.push(element)
                    }else{
                        items[order_index] = {
                            ...items[order_index],
                            ...element
                        }
                    }
                });
            }
            if(!items){return null}
            const list = [...items]
            list.sort(this.MBS.actions.dynamicSort("key",false))     
            return list 
        }, 
        ActiveOrders(){  
            const orders = this.LiveLocalItemOrder  
            if(!orders){return null}
            const filtered = orders.filter(order=>!order.deleted)    
            return filtered 
        }, 




        IsRetail(){
            const settings = this.CompanySettings
            if(!settings){return false}
            const only_retail_model = settings?settings.only_retail_model:false
            const only_wholesale_model = settings?settings.only_wholesale_model:false
            if (settings.both_selling_mode && !only_wholesale_model) {
                return true  
            } 
            return only_retail_model
        },
        IsWholesale(){
            const settings = this.CompanySettings
            if(!settings){return false}
            const only_retail_model = settings?settings.only_retail_model:false
            const only_wholesale_model = settings?settings.only_wholesale_model:false

            if (settings.both_selling_mode && !only_retail_model) {
                return true  
            } 
            return only_wholesale_model
        },
        DataInvoicePayments(){
            let Payments = this.Payments
            let JoinedPayments = this.JoinedPayments 
            return JoinedPayments?JoinedPayments:Payments
        },
        AllSaleOrdersData(){  
            const SaleOrders = this.SaleOrders
            const JoinedSaleOrders = this.JoinedSaleOrders
            let items = JoinedSaleOrders?JoinedSaleOrders:SaleOrders  
            // let dd = this.DaySalesData
            // items = dd?dd:items
            // console.log(dd,'ddddd..s..............');
            if(!items){return null} 
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",true)) 
            return list
        }, 
        AllLocalSaleOrdersData(){  
            const LocalSaleOrders = this.LocalSaleOrders
            const JoinedLocalSaleOrders = this.JoinedLocalSaleOrders
            let items = JoinedLocalSaleOrders?JoinedLocalSaleOrders:LocalSaleOrders  
            if(!items){return null} 
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",true)) 

            console.log(list,'ccccccccccccccccccc');
            
            return list
        },
        uploaded_localOrders(){
            const orders = this.AllLocalSaleOrdersData
            const eisO = orders?.filter(order=>order.uploaded)
            return eisO
        },
        not_uploaded_localOrders(){
            const orders = this.AllLocalSaleOrdersData
            const eisO = orders?.filter(order=>!order.uploaded)
            return eisO
        },
        EIS_Orders(){
            const orders = this.AllLocalSaleOrdersData
            const eisO = orders?.filter(order=>order.eis_payload)
            return eisO
        },
        EIS_uploadedOrders(){
            const orders = this.EIS_Orders
            const eisO = orders?.filter(order=>order.eis_payload && order.eis_payload?.uploaded)
            return eisO
        },
        EIS_not_uploadedOrders(){
            const orders = this.EIS_Orders
            const eisO = orders?.filter(order=>order.eis_payload && !order.eis_payload.uploaded)
            return eisO
        },
        AllLocalCashupsData(){  
            const LocalCashups = this.LocalCashups
            // const JoinedLocalCashups = this.JoinedLocalCashups
            // let items = JoinedLocalCashups?JoinedLocalCashups:LocalCashups  
            let items = LocalCashups  
            if(!items){return null} 
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",true)) 
            return list
        },
        TillsData(){
            return this.JoinedTills?this.JoinedTills:this.Tills
        }, 
        PaidInvoicesData(){ 
            let items = this.JoinedPaidInvoices?this.JoinedPaidInvoices:this.PaidInvoices 
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",true))  
            return list 
        }, 

        CurrentDayShift(){ 
            let shifts = this.DayShifts 
            let cashup = this.LocalCashup 
            let day_shift_key = cashup?.day_shift_key
            if(!shifts || !day_shift_key){return null}
            let filled = shifts.find(item=>{
                return item.key == day_shift_key
            })
            return filled
        },
        CurrentTill(){
            let tills = this.TillsData
            let cashup = this.LocalCashup 
            if(!tills || !cashup){return null}
            let filled = tills.find(item=>{
                return item.key == cashup.till_key
            })
            return filled
        },
        CurrentServer(){
            const device = this.CurrentTill
            const server_code = device?.server_code  
            const server = this.findServer(server_code)
            return server
        },
        ESI_TerminalConfiguration(){
            let till= this.CurrentTill
            const configuration = till?.eis_terminal?.configuration 
            const latest_configuration = till?.eis_terminal?.latest_configuration 
            return latest_configuration?latest_configuration: configuration
        },
        CurrentTillPrinters(){
            let till = this.CurrentTill 
            const printers =  till?till.printers:null
            if(!printers) {return null}
            let list = [...printers]
            list.sort(this.MBS.actions.dynamicSort("printer_priority",true))
            return list
        },
        CashDrawerPrinter(){
            const prints = this.CurrentTillPrinters
            const printer = prints?.find(p=>p.connect_cash_drawer == "Yes")
            return printer
        }, 
        CashupSaleOrders(){ 
            let items = this.AllLocalSaleOrdersData
            // let dd = this.DaySalesData
            // items = dd?dd:items
            // console.log(dd,'ddddd..11s..............');
            // console.log(items,'items..11s.......d.......');
            let cashup_key = this.LocalCashup?this.LocalCashup.key:null
            if(!items){return null}
            let filtered_items = items.filter(item=>{
                // return true
                return item.cashup_key == cashup_key
            })   
            return filtered_items
        },   
        MyCompanies(){ 
            return this.$store.getters.getMyCompanies
        },
        JoinedMyCompanies(){ 
            const companies = this.MyCompanies 
            if(!companies){return null}
            let joined = this.MBS.actions.JOIN({
                name:DATA.ITEMS.COMPANIES.values,
                items:companies
            })  
            return joined
        },
        selectedCompany(){ 
            return this.$store.getters.getSelectedCompany
        },   
        LocalCashup(){   
            let cashups = this.LocalCashups
            let local_cashup = cashups?cashups.find(item=>{
                return !item.closed
            }):null 
            return local_cashup
        },
        Joined_LocalCashup(){   
            let localCashup = this.LocalCashup
            let joined = this.MBS.actions.JOIN_CASHUP(localCashup)  
            return joined
        },
        // SaleOrders(){ 
        //     let items = this.$store.getters.getSaleOrders 
        //     let cashup_key = this.LocalCashup?this.LocalCashup.key:null
        //     if(!items){return null}
        //     let filtered_items = items.filter(item=>{
        //         return !item.archive && item.cashup_key == cashup_key
        //     }) 
        //     let list = [...filtered_items]
        //     list.sort(this.MBS.actions.dynamicSort("local_created_at",true))  
        //     return list
        // }, 
        // Joined_SaleOrders(){   
        //     let orders = this.SaleOrders 
        //     let joined = this.MBS.actions.JOIN_SALE_ORDERS(orders)  
        //     return joined
        // },
         

        CashOrders(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null}  
            let filtered_items = orders.filter(element => {
                return element.account_type == "cash"
            });
            return filtered_items
        },
        OnAccountOrders(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null}  
            let filtered_items = orders.filter(element => {
                return element.account_type == "on_account"
            });
            return filtered_items
        },
        TotalDiscount(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null} 
            let total = 0 
            orders.forEach(element => {
                let total_discount = toNumber(element.total_discount)
                total = total+total_discount
            });
            return total
        },
        CashTotalDiscount(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null} 
            let total = 0 
            orders.forEach(element => {
                if (element.account_type == "cash") {
                    let total_discount = toNumber(element.total_discount)
                    total = total+total_discount 
                }
            });
            return total
        },
        OtherPaymentTotalDiscount(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null} 
            let total = 0 
            orders.forEach(element => {
                if (element.account_type == "payment_option") {
                    let total_discount = toNumber(element.total_discount)
                    total = total+total_discount 
                }
            });
            return total
        },
        OnAccountTotalDiscount(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null} 
            let total = 0 
            orders.forEach(element => {
                if (element.account_type == "on_account") {
                    let total_discount = toNumber(element.total_discount)
                    total = total+total_discount 
                }
            });
            return total
        },
        MultiplePayOrders(){
            const orders = this.CashupSaleOrders
            if(!orders){return null}
            const m_orders = orders.filter(order=>order.input_payments) 
            return m_orders
        },
        InputPayments(){
            const orders = this.MultiplePayOrders 
            let amounts = []
            if(orders){
                orders.forEach(order => {
                    const total_given_amount = this.toNumber(order.given_amount)
                    const total_paid_amount = this.toNumber(order.sum_amount?order.sum_amount:order.paid_amount)
                    const change_amount = total_given_amount-total_paid_amount
                    const discount = this.toNumber(order.total_discount)
                    const input_payments = order.input_payments
                    const account_type = order.account_type
                    if (input_payments&&account_type == 'multiple') {
                        for (let index = 0; index < input_payments.length; index++) {
                            const element = input_payments[index];
                            let given_amount = this.toNumber(element.given_amount)
                            if (element.key == 'cash') {
                                given_amount=given_amount-change_amount
                            }
                            let indexOf = amounts.findIndex(item=>item.key==element.key)
                            if (indexOf==-1) {
                                amounts.push({
                                    ...element,
                                    given_amount:given_amount
                                })
                            } else {
                                amounts[indexOf].given_amount = amounts[indexOf].given_amount+given_amount
                            }

                        } 
                    }
                });
            }  
            return amounts
        },
        InputCashPayments(){
            const payments = this.InputPayments
            if(!payments){return 0}
            let cash = payments.find(pay=>pay.key=="cash") 
            return cash?cash.given_amount:0
        },
        InputOtherPayments(){
            const payments = this.InputPayments
            if(!payments){return 0}
            let amount = 0
            payments.forEach(pay => {
                if (pay.key!="cash") {
                    amount = amount+pay.given_amount
                }
            }); 
            return amount
        },
        OrdersItems(){ 
            this.MultiplePayOrdersAmounts  
            let orders = this.CashupSaleOrders 
            if(!orders){return null} 
            let items = [] 
            orders.forEach(element => {
                let joined_items = element.joined_items
                if (!joined_items) {
                    joined_items = element.items
                }
                if (joined_items) {
                    let items_size = 0
                    joined_items.forEach(element => {
                        items_size = items_size+this.toNumber(element.quantity)
                    });
                    let total_discount = this.toNumber(element.total_discount)
                    let average_order_total_discount = total_discount?(total_discount/items_size):0 


                    joined_items.forEach(item => { 
                        items.push({
                            ...item,
                            account_type:element.account_type,
                            payment_option_key:element.payment_option_key,
                            average_order_total_discount:average_order_total_discount,
                            average_item_quantity : items_size
                        }) 
                    });
                    
                }
            });
            return items
        },
        CardMoneyLoadOrders(){   
            let orders = this.CashupSaleOrders
            if(!orders){return null}  
            let filtered = orders.filter(order=>{
                return order.selected_card_option=="load_money"
            }) 
            return filtered
        },
        CashCardMoneyLoadOrders(){   
            let orders = this.CardMoneyLoadOrders
            if(!orders){return null}  
            let filtered = orders.filter(order=>{
                return order.account_type=="cash"
            }) 
            return filtered
        },
        OtherOptionCardMoneyLoadOrders(){   
            let orders = this.CardMoneyLoadOrders
            if(!orders){return null}  
            let filtered = orders.filter(order=>{
                return order.account_type=="payment_option"
            }) 
            return filtered
        },

        OrdersPricingTiers(){   
            let items = this.OrdersItems  
            let pricing_tiers = this.AllPricingTiers
            if(!items){return null}  
            let tiers = [] 
            items.forEach(item => { 
                let pricing_tier_key = item.pricing_tier_key?item.pricing_tier_key:"retail_price"
                let sold_price = this.toNumber(item.sold_price)
                let quantity = this.toNumber(item.quantity)
                let discount = this.toNumber(item.discount)
                let sum_amount = (sold_price-discount)*quantity
                let index = tiers.findIndex(item=>item.key==pricing_tier_key)
                if (index==-1) {
                    let tier = pricing_tiers?pricing_tiers.find(item=>item.key == pricing_tier_key):null
                    let tier_details = {
                        pricing_tier_key:pricing_tier_key,
                        sold_price:sold_price,
                        quantity:quantity,
                        sum_amount:sum_amount,
                        size:1
                    }
                    if (tier) {
                        tier_details = {
                            ...tier,
                            ...tier_details,
                        }
                    }else{
                        console.log(tier,'tiers......ii.');
                        console.log(item,'item......ii.');
                    }
                    tiers.push(tier_details)
                } else {
                    tiers[index].sold_price = tiers[index].sold_price+sold_price
                    tiers[index].quantity = tiers[index].quantity+quantity
                    tiers[index].sum_amount = tiers[index].sum_amount+sum_amount
                    tiers[index].size++ 
                }
                
            }); 
             
            return tiers
        }, 


        CashOrdersItems(){   
            let orders = this.OrdersItems
            if(!orders){return null}  
            let filtered_items = orders.filter(element => {
                return element?.account_type == "cash" || element?.payment_option_key == "cash"
            });
             
            return filtered_items
        },
        OtherOptionPaymentsOrdersItems(){   
            let orders = this.OrdersItems
            if(!orders){return null}  
            let filtered_items = orders.filter(element => {
                return element.account_type == "payment_option" &&  element?.payment_option_key != "cash"
            });  
            return filtered_items
        },
        OnAccountOrdersItems(){   
            let orders = this.OrdersItems
            if(!orders){return null}  
            let filtered_items = orders.filter(element => {
                return element.account_type == "on_account"
            });
            return filtered_items
        }, 
        liveTime(){
            let time = this.MBS.date.live 
            return time
        },
        LiveLocalCashup(){  
            let localCashup = this.Joined_LocalCashup 
            let live = this.liveTime
            let moment = this.MBS.date.moment
            let local_created_at = localCashup?localCashup.local_created_at:null 
            if (local_created_at) {
                let diff_hours = moment(live).diff(local_created_at,'hours')
                let diff_minute = moment(live).diff(local_created_at,'minutes')
                let diff_seconds = moment(live).diff(local_created_at,'seconds')
                let sec = diff_seconds - (diff_minute*60)
                let min = diff_minute - (diff_hours*60)
                return ''+diff_hours+'h '+min+'m '+sec+'s'
            }  
            return moment(local_created_at).format('yyyy-MM-D .')
        },

        
        DayShifts(){ 
            let items = this.$store.getters.getDayShifts
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",false)) 

            return list
        },  
        Joined_DayShifts(){ 
            let items = this.DayShifts
            if(!items){return null}
            let list = this.MBS.actions.JOIN({
                name:DATA.ITEMS.DAYS_SHIFTS.values,
                items:items
            }) 
            return list
        },  
        UNCLOSED_DayShifts(){ 
            let items = this.Joined_DayShifts
            if(!items){return null}
            let filtered_items = items.filter(item=>{
                return !item.archive && !item.closing_cash
            }) 
            return filtered_items
        }, 
        DayShiftsTills(){ 
            let items = this.UNCLOSED_DayShifts
            if(!items){return null}
            let tills = []
            items.forEach(element => {
                let this_tills = element.joined_tills
                if (this_tills) {
                    tills = [
                        ...tills,
                        ...this_tills
                    ]
                }
            }); 
            return tills
        },   
        SelectInputFieldsItems(){  
            let Tills = this.DayShiftsTills  
            return { 
                Tills:Tills,  
            }
        }, 

        // ThisInvoicePayments(){
        //     let payments = this.DataInvoicePayments
        //     let LocalCashup = this.LocalCashup
        //     let cashup_key = LocalCashup?LocalCashup.key:null
        //     let day_shift_key = LocalCashup?LocalCashup.day_shift_key:null
        //     if(!payments||!day_shift_key){return null}
        //     let filled_items = payments.filter(item=>{
        //         return item.cashup_key == cashup_key && item.day_shift_key == day_shift_key
        //     }) 
        //     return filled_items
        // },
        
        ThisInvoicePayments(){
            let payments = this.PaidInvoicesData 
            let LocalCashup = this.LocalCashup
            let cashup_key = LocalCashup?LocalCashup.key:null
            let day_shift_key = LocalCashup?LocalCashup.day_shift_key:null
            if(!payments||!day_shift_key){return null}
            let filled_items = payments.filter(item=>{
                return item.cashup_key == cashup_key && item.day_shift_key == day_shift_key
            }) 
            return filled_items
        },
        CashInvoicePayments(){
            let payments = this.ThisInvoicePayments   
            if(!payments){return null}
            let filled_items = payments.filter(item=>{
                return !item.payment_option_key||item.payment_option_key=="cash"
            }) 
            return filled_items
        },
        OtherInvoicePayments(){
            let payments = this.ThisInvoicePayments 
            if(!payments){return null}
            let filled_items = payments.filter(item=>{
                return item.payment_option_key!="cash"
            }) 
            return filled_items
        },
        
        DisabledCashupFields(){ 
            let settings = this.CompanySettings  
            let edit_closing_cash = settings?settings.edit_closing_cash:null
            if (!edit_closing_cash) {
                return ['closing_cash','expected_cash']
            }
            return null
        },  
        OtherSalesOptionPayments(){
            let items = this.OtherOptionPaymentsOrdersItems   
            let settings = this.CompanySettings   
            let vat_exclusive = settings?.items_are_vat_exclusive
            if(!items){return null}
            let options = []

            console.log(settings,'settings..................+++++');
            console.log(items,'items..................+++++');
            
            items.forEach(element => {
                let payment_option_key = element.payment_option_key
                let sold_price = this.toNumber(element.sold_price)
                let quantity = this.toNumber(element.quantity)
                let discount = this.toNumber(element.discount)+this.toNumber(element.average_order_total_discount)
                let price = (sold_price-discount) *quantity

                let tax_group_code = element?.tax_group_code 
                tax_group_code = tax_group_code?tax_group_code:"A" 
                let item_total_vat = 0
                let item_sum_amount = 0
                if (tax_group_code == "A" && vat_exclusive) {
                    item_total_vat = (sold_price*quantity)*17.5/100
                    item_sum_amount = price+item_total_vat
                } else {
                    item_sum_amount = price
                }


                let index = options.findIndex(option=>{
                    return option.payment_option_key  == payment_option_key
                }) 
                if (payment_option_key) {
                    if (index == -1) {
                        let payment_method = this.$store.getters.getPaymentMethodByKey(payment_option_key)
                        options.push({
                            payment_method:payment_method,
                            payment_method_name:payment_method?payment_method.name:"---",
                            payment_option_key:payment_option_key,
                            // amount:this.toNumber(element.sold_price)*this.toNumber(element.quantity),
                            amount:price,
                            total_vat : item_total_vat,
                            sum_amount : item_sum_amount,
                        })
                    } else {
                        options[index].amount = options[index].amount+price
                        options[index].total_vat = options[index].total_vat+item_total_vat
                        options[index].sum_amount = options[index].sum_amount+item_sum_amount
                                    
                    } 
                } 
            });   
            return options
        }, 
        OtherInvoiceOptionPayments(){
            let items = this.OtherInvoicePayments   
            if(!items){return null}
            let options = []
            items.forEach(element => {
                let payment_option_key = element.payment_option_key
                let index = options.findIndex(option=>{
                    return option.payment_option_key  == payment_option_key
                }) 
                if (payment_option_key) {
                    if (index == -1) {
                        let payment_method = this.$store.getters.getPaymentMethodByKey(payment_option_key)
                        options.push({
                            payment_method:payment_method,
                            payment_method_name:payment_method?payment_method.name:"---",
                            payment_option_key:payment_option_key,
                            amount:this.toNumber(element.amount) 
                        })
                    } else {
                        options[index].amount = options[index].amount+(this.toNumber(element.amount))
                    } 
                } 
            });  
            return options
        },
        TotalCurrency(){
            try { 
                let currencies = this.currency_list
                if(!currencies){0}
                let total = 0
                currencies.forEach(currency => {
                    total = total+(this.toNumber(currency.quantity)*this.toNumber(currency.value))
                });
                return total
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TotalPayments',
                    page:PAGE_NAME, 
                }) 
                return 0
            }  
        }, 
        
        Assistant(){    
            const cashup = this.LocalCashup
            const assistant_uid = cashup?.assistant_uid
            if(!assistant_uid){return null} 
            let assistant = {assistant_uid}
            const user = this.$store.getters.getUserByUid(assistant_uid) 
            if (user) {
                assistant = {...user,assistant_uid}
            } 
            return assistant
        }, 
        AssistantTill(){
            const data = this.CASHUP_REQUEST_DATA
            const tills = this.TillsData
            if(!data || !tills){return null}
            const till = tills.find(till=>till.key == data.till_key)
            return till 
        }, 
        AssistantTeller(){
            const data = this.CASHUP_REQUEST_DATA
            const assistant_uid = data?.assistant_uid
            const teller = this.$store.getters.getUserByUid(assistant_uid)  
            return teller 
        }, 

    },
    methods:{  
        async FI_INITIATE(){ 
            try {
                // let day_shift = this.day_shift
                let day_shift_key = "1719803588940"
                if (true) {
                    // this.downloading = true
                    let path_sales = this.MBS.actions.COMPANY_LINK(DATA.PATHS.days_shifts_sales+day_shift_key,true)
                    let path_orders = this.MBS.actions.COMPANY_LINK(DATA.PATHS.item_orders+day_shift_key,true)
                    // console.log(path_sales,'path_sales....... .......***');
                    // console.log(path_orders,'path_orders....... .......***');

                    // let res = await this.$store.dispatch("fi_get_day_sales",{
                    //     path:path_sales
                    // })  
                    // console.log(res, '-----------fi');


                    // this.$store.dispatch("fi_get_day_orders",{
                    //     path:path_orders
                    // }).then(res=>{
                    //     this.downloading = false
                    //     console.log(res,'res....FI_INITIATE.....');
                    // }).catch(error=>{
                    //     this.downloading = false
                    //     console.log(error,'error.....FI_INITIATE.......');
                    // })
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'FI_INITIATE',
                    page:PAGE_NAME, 
                }) 
            }
        }, 
        async INITIATE_LOCAL_SERVER(device,force){
            try { 
                const online = this.onlineLan
                const link = this.link_lan2
                let server = this.CurrentServer
                const server_code = device?.server_code 
                const lan = 2
                if (server_code && !server) {
                    server = this.$store.getters.getDeviceByCode(server_code)    
                }
                const network_ip_address_link = server?.network_ip_address_link 
                const network_link = network_ip_address_link+"/api/"
                if (!force && online && link == network_link) {
                    console.log(link,'same link.........................');
                    return
                }
                 
                this.$store.dispatch("lan_start",{device,lan})
                .then(res=>{
                    this.LAN_GET_ITEM_ORDERS()
                    console.log(res,"LAN2-----res------"); 
                }).catch(error=>{
                    console.log(error,"LAN2-----err------"); 
                }) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'INITIATE_LOCAL_SERVER',
                    page:PAGE_NAME, 
                })
            }  
        },


        FINISH_PRINT(action,payload){
            try {    
                let canceled = payload?payload.canceled:null
                if(!action){return}
                if (action.code == PAGE_NAME+"=CLOSE-CASHUP") {
                    // this.$store.dispatch("fi_uploadCashups")
                    // this.$store.dispatch("fi_uploadSales")
                    // this.SUBMIT_CLOSE_CASHUP(action.data) 
                    this.REFRESH_DATA()  
                }
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'FINISH_PRINT',
                    page:PAGE_NAME, 
                }) 
            } 
        },

        RESET_ALL_DATA(){ 
            try { 
                Object.assign(this.$data, this.$options.data())  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'RESET_ALL_DATA',
                    page:PAGE_NAME, 
                }) 
            }
        },
        TOTAL_AMOUNT(items){
            try {  
                let total_amount = 0 
                if (!items) {return 0}
                items.forEach(item => {
                    let amount = this.toNumber(item.amount) 
                    total_amount = total_amount + amount
                });  
                return total_amount
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TOTAL_AMOUNT',
                    page:PAGE_NAME, 
                }) 
                return 0
            }  
        },  
        TOTAL_PAID_AMOUNT(items){
            try {  
                let total_amount = 0 
                if (!items) {return 0}
                items.forEach(item => {
                    let amount = this.toNumber(item.sum_amount?item.sum_amount:item.paid_amount) 
                    total_amount = total_amount + amount
                });  
                return total_amount
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TOTAL_PAID_AMOUNT',
                    page:PAGE_NAME, 
                }) 
                return 0
            }  
        },  
        UPLOADED(items){
            try { 
                if(!items){return null}
                return items.filter(item=>{
                    return item.uploaded
                })  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'UPLOADED',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        UN_UPLOADED(items){
            try { 
                if(!items){return null}
                return items.filter(item=>{
                    return !item.uploaded
                })  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'UPLOADED',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        TOTAL_SOLD(items){
            try {  
                let total = 0
                if (items) {
                    items.forEach(element => {
                        let sold_price = this.toNumber(element.sold_price)
                        let quantity = this.toNumber(element.quantity)
                        let discount = this.toNumber(element.discount)
                        let average_order_total_discount = this.toNumber(element.average_order_total_discount)
                        // discount = discount+average_order_total_discount
                        total = total+((sold_price-discount-average_order_total_discount)*quantity)
                    }); 
                }
                return total
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TOTAL_SOLD',
                    page:PAGE_NAME, 
                })
            }  
        },  
        TOTAL_EXPENSES(items){
            try {  
                let total = 0
                if (items) {
                    items.forEach(element => {
                        let amount = this.toNumber(element.amount) 
                        total = total+amount
                    }); 
                }
                return total
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TOTAL_EXPENSES',
                    page:PAGE_NAME, 
                })
            }  
        },  
        ON_CLOSE_REGISTER(payload){ 
            try { 
                let settings = this.CompanySettings  
                let cashup_before_closing_till = settings?settings.cashup_before_closing_till:null
                let till_require_no_password = settings?settings.till_require_no_password:null

                let TotalPayments = this.TOTAL_AMOUNT(this.CashInvoicePayments)
                let cashup = this.Joined_LocalCashup
                let total_cash = this.toNumber(this.TOTAL_SOLD(this.CashOrdersItems))
                let opening_cash = this.toNumber(cashup?cashup.opening_cash:0)
                let current_cash = total_cash+opening_cash+TotalPayments

                this.input = {}
                this.input.till_key = cashup?cashup.till_key:null 
                this.input.expected_cash = current_cash
                // if (!edit_closing_cash) {
                //     this.input.closing_cash = current_cash 
                // }
 
                this.input.shortage = this.toNumber(this.input.expected_cash) - this.toNumber(this.input.closing_cash)
                
                //OPEN CONFIRM DIALOG
                // this.dialog_confirm_before_closing = true  
                let mbs_text = payload?payload.mbs_text:null 
                mbs_text = mbs_text?mbs_text:{...this.MBS.text.item_action("Register","Close")}
                let dialog = this.MBS.actions.dialogConfirmPassword 
                if (till_require_no_password) {
                    dialog = this.MBS.actions.dialog
                }else{
                    mbs_text.text=mbs_text.text+" Enter your password to confirm this action."
                    mbs_text.btnYes = "CONFIRM PASSWORD"
                } 

                // this.CLOSE_REGISTER()
                dialog({
                    show:true,
                    fixed:true,
                    icon:"$printer-pos-pause",
                    title:mbs_text.title, 
                    text:mbs_text.text, 
                    btnYes:mbs_text.btnYes, 
                    btnNoColor:"error", 
                    btnNo:"FORCE CLOSING",  
                    action:{
                        code:PAGE_NAME+"=CONFIRM-CLOSE-REGISTER",
                        silent_btn_no:true,
                        phone_number_start:true,
                        all_users:true,
                        get_access:{
                            page_name:"Sale", 
                        }
                    }
                })
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_CLOSE_REGISTER',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        CONFIRM_BEFORE_CLOSING(payload){
            try { 
                const ud = payload?.ud 
                this.closing_us = ud
                const all_orders = this.LiveLocalItemOrder
                const active_orders = this.ActiveOrders
                const Assistant = this.Assistant
                if (Assistant) {
                    this.CONFIRM_CLOSING_REGISTER()
                // } else  if (this.MBS.actions.SIZE(active_orders)) {
                } else  if (false) {
                    // IF ACTIVE ORDERS, CLOSE FIRST
                    let mbs_text = this.MBS.text.item_action("Active Orders First","Close")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-cart",
                        title:"YOU HAVE OPEN ORDERS", 
                        text:"Hey there! It looks like you have some open orders. You'll need to close them out before you can close the register.\n\n Here are your options: \n 1. Close Orders: Go ahead and close each order individually. \n 2. Send to Unpaid Bills: If you want to put all these orders on a customer's account, click \"SEND UNPAID BILLS\".", 
                        btnNo:"CLOSE ORDERS", 
                        btnYes:"SEND UNPAID BILLS", 
                        btnNoColor:"error", 
                        action:{
                            code:PAGE_NAME+"=HAVE-OPEN-ORDERS",
                            silent_btn_no:true
                        }
                    })
                } else {
                    let settings = this.CompanySettings  
                    let cashup_before_closing_till = settings?settings.cashup_before_closing_till:null
                    let till_require_no_password = settings?settings.till_require_no_password:null
                    if (cashup_before_closing_till) {
                        this.dialog_confirm_before_closing = false
                        this.dialog_open_drawer_before_closing_register = true 
                        this.inputLoading = false  
                        setTimeout(() => { 
                            this.OPEN_DRAWER()
                        }, 100); 
                    } else {
                        this.CONFIRM_CLOSING_REGISTER()
                    } 
                } 

            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CONFIRM_BEFORE_CLOSING',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        CONFIRM_CLOSING_REGISTER(){
            try {  
                let mbs_text = this.MBS.text.item_action("Register","Close")
                this.MBS.actions.dialog({
                    show:true,
                    fixed:true,
                    title:mbs_text.title,
                    text:mbs_text.text,
                    btnYes:mbs_text.btnYes,  
                    btnNo:mbs_text.btnNo,  
                    action:{
                        code:PAGE_NAME+"=CLOSE-REGISTER"
                    }
                }) 
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CONFIRM_CLOSING_REGISTER',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        CONFIRM_FORCE_CLOSING_REGISTER(){
            try {   
                 
                let mbs_text = this.MBS.text.item_action("Register","Force Close")
                this.MBS.actions.dialog({
                    show:true,
                    fixed:true,
                    title:mbs_text.title,
                    text:mbs_text.text,
                    btnYes:mbs_text.btnYes,  
                    btnNo:mbs_text.btnNo,  
                    action:{
                        code:PAGE_NAME+"=FORCE-CLOSE-REGISTER"
                    }
                }) 
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CONFIRM_FORCE_CLOSING_REGISTER',
                    page:PAGE_NAME, 
                })
            }  
        },  
        async FORCE_CLOSING_REGISTER(data){
            try {   
                await this.CLOSE_REGISTER(data) 
                // this.RESET_ALL_DATA()
                setTimeout(() => {
                    this.MBS.actions.logout(true) 
                }, 500); 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CONFIRM_FORCE_CLOSING_REGISTER',
                    page:PAGE_NAME, 
                })
            }  
        },  
        async CLOSE_REGISTER(){
            return new Promise(async (resolve,reject)=>{
                try {    
                    const settings = this.CompanySettings
                    const print_closing_cashup = settings?settings.print_closing_cashup:null

                    const us = this.us
                    const closing_us = this.closing_us
                    const ud = closing_us?closing_us:us 
                    const uid = ud?ud.uid:null

                    let OrdersItems = this.OrdersItems
                    let cashup_total_sales = this.TOTAL_SOLD(OrdersItems)

                    const CashupExpenses = this.CashupExpenses
                    const CashExpenses = this.CashExpenses
                    const OtherExpenses = this.OtherExpenses
                    const OtherExpensesAccounts = this.OtherExpensesAccounts
                    const total_expenses = this.TOTAL_EXPENSES(CashupExpenses)
                    const cash_expenses = this.TOTAL_EXPENSES(CashExpenses)
                    const other_expenses = this.TOTAL_EXPENSES(OtherExpenses)
                    const other_expenses_account = OtherExpensesAccounts?OtherExpensesAccounts:null


                    let saleOrders = this.CashupSaleOrders
                    let uploadedSaleOrders = this.UPLOADED(saleOrders)
                    let unUploadedSaleOrders = this.UN_UPLOADED(saleOrders) 
                    let cashup_pricing_tiers = this.OrdersPricingTiers 
                    let cash_items = this.CashOrdersItems
                    let on_account_items = this.OnAccountOrdersItems 
                    let OtherSalesOptionPayments = this.OtherSalesOptionPayments 
                    let OtherInvoiceOptionPayments = this.OtherInvoiceOptionPayments 

                    let InputPayments = this.InputPayments 
                    let InputCashPayments = this.toNumber(this.InputCashPayments )
                    let InputOtherPayments = this.toNumber(this.InputOtherPayments )

                    
                     
     
    
                    let input = this.input
                    let till_key = input?input.till_key:null
                    let expected_cash = this.toNumber(input?.expected_cash)-cash_expenses
                    // let closing_cash = input?input.closing_cash:null
                    let closing_cash = this.TotalCurrency
                    let currencies = this.currency_list
                    let description = input?input.description:''
                    let moment = this.MBS.date.moment
                    let key = moment?moment().valueOf():null
                    
                    let data = {
                        ...this.LocalCashup,
                        expenses:{total_expenses,cash_expenses,other_expenses,other_expenses_account},

                        cashup_total_sales:cashup_total_sales,
                        cashup_pricing_tiers:cashup_pricing_tiers,

                        closing_currencies:currencies,
                        closing_cash:this.toNumber(closing_cash),
                        expected_cash:this.toNumber(expected_cash), 
    
                        sales_on_account:this.toNumber(this.TOTAL_SOLD(on_account_items)),  
    
                        sales_cash_payments:this.toNumber(this.TOTAL_SOLD(cash_items))+InputCashPayments,  
                        invoices_cash_payments:this.toNumber(this.TOTAL_AMOUNT(this.CashInvoicePayments)), 
     
                        close_at:key, 
                        closed:true, 
                        local_updated_at:key, 
                        closing_uid:uid,
                        uploaded:false
                    }  
                    if (OtherSalesOptionPayments) {
                        data.sales_other_option_payments = {}
                        data.sales_total_other_option_payments = InputOtherPayments
                        OtherSalesOptionPayments.forEach(element => {
                            data.sales_other_option_payments[element.payment_option_key] = {
                                payment_option_key : element.payment_option_key,
                                amount : element.amount,
                                total_vat : element.total_vat,
                                sum_amount : element.sum_amount,
                            }
                            data.sales_total_other_option_payments = data.sales_total_other_option_payments+this.toNumber(element.amount)
                        });
                    }
    
                    if (OtherInvoiceOptionPayments) {
                        data.invoices_other_option_payments = {}
                        data.invoices_total_other_option_payments = 0
                        OtherInvoiceOptionPayments.forEach(element => {
                            data.invoices_other_option_payments[element.payment_option_key] = {
                                payment_option_key : element.payment_option_key,
                                amount : element.amount,
                            }
                            data.invoices_total_other_option_payments = data.invoices_total_other_option_payments + this.toNumber(element.amount)
                        });
                    }
                    if(description){data.description=description}
                    if(InputPayments){data.InputPayments=InputPayments} 

                    this.inputLoading = true
                    let res =  await DB.addItems({
                        name:DATA.ITEMS.LOCAL_CASHUPS.values,
                        data:data,
                        update_locals:true,   
                    })   

                    // this.$store.dispatch("fi_uploadCashups")
                    // this.$store.dispatch("fi_upload_day_shifts")
                    this.$store.dispatch("fi_uploadSales")
                    // this.SUBMIT_CLOSE_CASHUP(data) 
                   
                   
                    this.$store.dispatch("upload_locals")
                    if (print_closing_cashup) {
                        let printer = this.CurrentTillPrinters?.[0]
                        let printer_name = printer?printer.name:null
                        let printer_type_name = printer?printer.printer_type_name:null 
                        this.auto_print.printing = false
                        setTimeout(() => {  
                            this.REFRESH_DATA() 
                            this.auto_print.auto_printer_name = printer_name
                            this.auto_print.print_data = data 
                            this.auto_print.printing = true   
                            this.auto_print.auto = false   
                            this.auto_print.print_type = 'cashup'   
                            this.auto_print.printing_action={
                                code:PAGE_NAME+"=CLOSE-CASHUP",
                                data:data
                            } 
                        }, 0);  
                    }else{
                        setTimeout(() => {
                            this.REFRESH_DATA() 
                        }, 1000);
                    }
                    
                    resolve({success:true})
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CLOSE_REGISTER',
                        page:PAGE_NAME, 
                    }) 
                    reject(error)
                }  
            })
        },
        UPLOAD_SALES(data){
            return new Promise(async (resolve,reject)=>{
                try {    
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Uploading Sales...."
                    }) 
                    this.$store.dispatch("fi_uploadSales")
                    .then(async res=>{   
                        this.MBS.actions.progressDialog() 
                        this.SUBMIT_CLOSE_CASHUP(data)
                    }).catch(error=>{
                       console.log(error,'error.......');
                       this.MBS.actions.progressDialog() 
                       let mbs_text = this.MBS.text.item_action_fail("Sales","Uploading")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPLOAD_SALES',
                        page:PAGE_NAME, 
                    }) 
                }  
            })
        },
        REFRESH_DATA(){
            // this.dialog_open_drawer_before_closing_register = false 
            // this.dialog=false, 
            // this.input={}, 
            // this.menuSelect=false,
            // this.dialog_drawer_close_register=false,   
            // this.currency_list=[
            //     {value:1,name:"1.00",icon:"mdi-cash"},
            //     {value:5,name:"5.00",icon:"mdi-cash"},
            //     {value:10,name:"10.00",icon:"mdi-cash"},
            //     {value:20,name:"20.00",icon:"mdi-cash"},
            //     {value:50,name:"50.00",icon:"mdi-cash"},
            //     {value:100,name:"100.00",icon:"mdi-cash"},
            //     {value:200,name:"200.00",icon:"mdi-cash"},
            //     {value:500,name:"500.00",icon:"mdi-cash"},
            //     {value:1000,name:"1,000.00",icon:"mdi-cash"},
            //     {value:2000,name:"2,000.00",icon:"mdi-cash"},
            //     {value:5000,name:"5,000.00",icon:"mdi-cash"},
            // ]

            Object.assign(this.$data, this.$options.data()) 
        },
        ON_SYNC_TERMINAL(){ 
            try {  
                let mbs_text  = {...this.MBS.text.item_action("Terminal","Sync")} 
                this.MBS.actions.dialog({
                    show:true,
                    fixed:true,
                    icon:"mdi-cloud-refresh-variant",
                    title:mbs_text.title, 
                    text:mbs_text.text, 
                    btnYes:mbs_text.btnYes, 
                    btnNoColor:mbs_text.btnYes, 
                    btnNo:mbs_text.btnNo,  
                    action:{
                        code:PAGE_NAME+"=SYNC-TERMINAL",
                        silent_btn_no:true,
                        phone_number_start:true,
                        all_users:true, 
                    }
                })
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_SYNC_TERMINAL',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        ON_PING_SERVER(){ 
            try {  
                let mbs_text  = {...this.MBS.text.item_action("server","ping")} 
                this.MBS.actions.dialog({
                    show:true,
                    fixed:true,
                    icon:"mdi-cloud-refresh-variant",
                    title:mbs_text.title, 
                    text:mbs_text.text, 
                    btnYes:mbs_text.btnYes, 
                    btnNoColor:mbs_text.btnYes, 
                    btnNo:mbs_text.btnNo,  
                    action:{
                        code:PAGE_NAME+"=PING-SERVER",
                        silent_btn_no:true,
                        phone_number_start:true,
                        all_users:true, 
                    }
                })
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_SYNC_TERMINAL',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        GET_LATEST_CONFIGURATION({notify,show_snack}){
                try {     
                    const till = this.CurrentTill
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 

                    const upload_data ={
                        path:"refresh-config",
                        is_full_path:false,
                        data:{
                            production:DATA.EIS.production,
                            company_key,
                            till_key:till?.key,  
                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    if (notify) {
                        this.MBS.actions.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Reloading.."
                        })  
                    }
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        let mbs_text = this.MBS.text.item_action_success("Latest Eis Configuration","Getting")
                        if (notify) {
                            this.MBS.actions.progressDialog() 
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                        if (show_snack) {
                            this.MBS.actions.snackbar({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        let mbs_text = this.MBS.text.item_action_fail("Latest Eis Configuration","Getting")
                        if (notify) {
                            this.MBS.actions.progressDialog() 
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text+" ("+error_res+")",
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })
                            
                        }
                        if (show_snack) {
                            this.MBS.actions.snackbar({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text+" ("+error_res+")",
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })
                        }
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
        },
        PING_SERVER(){
                try {     
                    const till = this.CurrentTill
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"eis-ping-server",
                        is_full_path:false,
                        data:{
                            production:DATA.EIS.production,
                            company_key,
                            till_key:till?.key,  
                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Reloading.."
                    }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_success("Server","ping")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail("Server","ping")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+error_res+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
        },
        EIS_CHECK_BLOCK_STATUS(){
                try {     
                    const till = this.CurrentTill
                    const SelectedCompany = this.SelectedCompany           
                    const company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"eis-check-terminal-blocking-message",
                        is_full_path:false,
                        data:{
                            production:DATA.EIS.production,
                            company_key,
                            till_key:till?.key,  
                        }
                    } 
                    // this.inputLoading = true 
                    // this.MBS.actions.progressDialog({
                    //     show:true,
                    //     fixed:false,
                    //     title:"Reloading.."
                    // }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............block message');
                        return this.MBS.actions.POST_REQUEST({
                            ...upload_data,
                            path:"eis-check-terminal-unblock-status"
                        })
                    }).then(res=>{
                        console.log(res,'res in............unblock status');
                        // this.dialog_integrate_eis = false
                        // this.inputLoading = false
                        // this.MBS.actions.progressDialog() 
                        // let mbs_text = this.MBS.text.item_action_success("Server","ping")
                        // this.MBS.actions.dialog({
                        //     show:true,
                        //     fixed:true,
                        //     title:mbs_text.title,
                        //     text:mbs_text.text,
                        //     btnYes:mbs_text.btnYes,
                        //     btnNo:mbs_text.btnNo, 
                        // })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        // let error_res = error?.error?.body?.error
                        // error_res = error_res?error_res:""
                        // this.inputLoading = false
                        // this.MBS.actions.progressDialog() 
                        // let mbs_text = this.MBS.text.item_action_fail("Server","ping")
                        // this.MBS.actions.dialog({
                        //     show:true,
                        //     fixed:true,
                        //     title:mbs_text.title,
                        //     text:mbs_text.text+" ("+error_res+")",
                        //     btnYes:mbs_text.btnYes,
                        //     btnNo:mbs_text.btnNo, 
                        // })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
        },
        SYNC_EIS_PRODUCTS(){
            try {     
                const till = this.CurrentTill
                let SelectedCompany = this.SelectedCompany           
                let company_key = SelectedCompany?SelectedCompany.company_key:null 
                const upload_data ={
                    path:"sync-mra-items-to-inventory",
                    is_full_path:false,
                    data:{
                        production:DATA.EIS.production,
                        company_key,
                        till_key:till?.key,  
                    }
                }
                console.log(upload_data,'upload_data-----------');
                
                this.inputLoading = true 
                this.MBS.actions.progressDialog({
                    show:true,
                    fixed:false,
                    title:"Reloading.."
                }) 
                this.MBS.actions.POST_REQUEST(upload_data)
                .then(res=>{
                    console.log(res,'res in............tt');
                    this.dialog_integrate_eis = false
                    this.inputLoading = false
                    this.MBS.actions.progressDialog() 
                    let mbs_text = this.MBS.text.item_action_success("Eis Terminal","Confirming")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                    })
                }).catch(error=>{
                    console.log(error,'Err in............tt');
                    let error_res = error?.error?.body?.error
                    error_res = error_res?error_res:""
                    this.inputLoading = false
                    this.MBS.actions.progressDialog() 
                    let mbs_text = this.MBS.text.item_action_fail("Eis Terminal","Confirming")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text+" ("+error_res+")",
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                    })
                    
                })
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CONFIRM_EIS',
                    page:PAGE_NAME, 
                }) 
            } 
            
        },

        // async SUBMIT_CLOSE_CASHUP(data){
        //     try {   
        //         this.inputLoading = true
        //         if (data) { 
        //             this.inputLoading = false
        //             this.dialog_drawer_close_register = false 
        //             let saleOrders = this.AllLocalSaleOrdersData
        //             let cashups = this.AllLocalCashupsData
        //             let uploadedSaleOrders = this.UPLOADED(saleOrders) 
        //             let uploadedCashups = this.UPLOADED(cashups) 
        //             if (uploadedSaleOrders) {
        //                 for (const order of uploadedSaleOrders) {
        //                     let order_key = order.key
        //                     if (order_key) {
        //                         await DB.deleteItems({
        //                             key:order_key,
        //                             name:DATA.ITEMS.LOCAL_SALE_ORDERS.values,
        //                         }) 
        //                     }   
        //                 } 
        //             }
        //             if (uploadedCashups) {
        //                 for (const order of uploadedCashups) {
        //                     let order_key = order.key
        //                     if (order_key) {
        //                         DB.deleteItems({
        //                             key:order_key,
        //                             name:DATA.ITEMS.LOCAL_CASHUPS.values,
        //                         }) 
        //                     } 
        //                 }  
        //             }
        //             this.MBS.events.$emit("SUBMIT_SALES")
        //             this.MBS.events.$emit("SUBMIT_CASHUPS",PAGE_NAME)
        //         }else {
        //             this.inputLoading = false
        //             this.MBS.actions.error({
        //                 error:"no data",
        //                 from:'SUBMIT_CLOSE_CASHUP',
        //                 page:PAGE_NAME, 
        //             }) 
        //         } 
        //     } catch (error) {
        //         this.MBS.actions.error({
        //             error:error,
        //             from:'SUBMIT_CLOSE_CASHUP',
        //             page:PAGE_NAME, 
        //         }) 
        //     } 
        // },
        
        async CHECK_TILL(cashup){
            try {
                let selected_company = this.SELECTED_COMPANY
                let route = this.route
                let fullPath = route?route.fullPath:null
                let params = route?route.params:null
                let id = params?params.id:null  
                let company_key = cashup?cashup.company_key:null  
                if (!selected_company && company_key) {
                    this.MBS.actions.dialog()
                    this.SELECT_COMPANY({company_key:company_key})
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHECK_TILL',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        async SELECT_COMPANY(company){
            try {
                let route = this.route
                let fullPath = route?route.fullPath:null
                let params = route?route.params:null
                let id = params?params.id:null   
                await this.MBS.actions.SELECT_COMPANY(company)
                if (id) {
                    // let mainPath = fullPath.split(id).pop()
                    let newPath = fullPath.replace(id,company.company_key)
                    this.MBS.actions.go(newPath)
                }
                this.menuSelect = false

            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'SELECT_COMPANY',
                    page:PAGE_NAME, 
                })
            }  
        },  

        OPEN_DRAWER(){
            try {    
                //check connector 
                let onlineLan = this.onlineLan
                let settings = this.CompanySettings
                let Sell_without_printer = settings?settings.Sell_without_printer:null
                let printer = this.CashDrawerPrinter 
                if (onlineLan) { 
                    this.inputLoading = true
                    this.$store.dispatch("lan_print",{ 
                        printer:printer, 
                        lan:2,
                        print_option:{open_drawer:1} 
                    })
                    .then(res=>{
                        console.log(res,'res drawer-----------');
                        
                        this.inputLoading = false
                        this.dialog_open_drawer = false
                    }).catch(error=>{
                        this.inputLoading = false
                        this.MBS.actions.dialog()
                        console.log(error,'error drawer-----------');
                        setTimeout(() => {
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:"ERROR",
                                text:'Unable to open drawer. ('+error.message+')',
                                btnYes:"TRY AGAIN",  
                                btnNo:"CANCEL",  
                                action:{
                                    code:PAGE_NAME+"=OPEN-DRAWER"
                                }
                            })   
                        }, 100);
                    })
                }else if (Sell_without_printer) {
                        
                } else {
                    this.inputLoading = false
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:"CONNECTOR IS OFF",
                        text:'Kipcount Connector is offline. Please make sure to start the K-Connector and try again.',
                        btnYes:"TRY AGAIN",  
                        btnNo:"CANCEL",  
                        action:{
                            code:PAGE_NAME+"=K-CONNECT"
                        }
                    })  
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'OPEN_DRAWER',
                    page:PAGE_NAME, 
                }) 
            } 
        },

        async COMPANY_QUICK_ACTIONS(actions){
            try {    
                if (actions) {
                    const cashup = this.LocalCashup
                    const cashup_key = cashup?.key
                    const current_till = this.CurrentTill
                    const till_key = current_till?current_till.key:null
                    actions.forEach(async action => {
                        if (cashup_key == action.cashup_key) {
                            if (action.action == "ask_to_close") {
                                this.MBS.actions.dialog({
                                    show:true,
                                    fixed:true,
                                    title:"CLOSE REGISTER",
                                    text:"Admin, is requesting to close the register.",
                                    btnYes:"CLOSE REGISTER",
                                    btnNo:"NOT NOW",
                                    action:{
                                        code:PAGE_NAME+"=ASK-TO-CLOSE-REGISTER",
                                        data:action
                                    }
                                })  
                                this.DELETE_COMPANY_QUICK_ACTION(action)
                            } 
                            if (action.action == "for_close_register") {
                                await this.FORCE_CLOSING_REGISTER(action) 
                                this.MBS.actions.dialog({
                                    show:true,
                                    fixed:true,
                                    title:"FORCE CLOSED REGISTER",
                                    text:"Admin,  closed the register.",
                                    btnYes:"OKAY", 
                                    // action:{
                                    //     code:PAGE_NAME+"=FORCE-CLOSE-REGISTER",
                                    //     data:action
                                    // }
                                })  
                                this.DELETE_COMPANY_QUICK_ACTION(action)
                                console.log(action, 'fffff...................xxxxxxx');
                                
                            } 
                            
                        } else  if (till_key && till_key==action.till_key) {
                             console.log(action, 'fffff...................xxxxxxx222');
                        }
                    });   
                } 
                    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ITEM_ACTION',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        DELETE_COMPANY_QUICK_ACTION(action){ 
            try { 
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.company_quick_actions+action.key,true) 
                this.$store.dispatch("fi_delete",{
                    action:DATA.ITEMS.COMPANY_QUICK_ACTIONS.values,
                    path:path, 
                }).then(res=>{ 
                }).catch(error=>{
                    console.log(error,'error.....'); 
                })
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'DELETE_COMPANY_QUICK_ACTION',
                    page:PAGE_NAME, 
                }) 
            }
        },
        RECEIVE_ASSISTANT_JOIN_REQUEST({data,is_array,action}){
            try {  
                const cashup = this.LocalCashup 
                const till = this.CurrentTill  
                const request_data = is_array?data?.[0]:data    
                console.log(request_data,"request_data.....");
                console.log(cashup,"cashup.....");
                 
                if (request_data && cashup?.key == request_data?.cashier_cashup_key) {
                    if (!request_data.join_approved_uid && !request_data.join_rejected_uid) {
                        this.CASHUP_REQUEST_DATA = request_data
                        this.dialog_receive_join_assistant_request = true
                        this.MBS.events.$emit("PLAY_SOUND",) 
                    } 
                    if(request_data.join_canceled_uid){ 
                        this.dialog_receive_join_assistant_request = false
                    }
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'RECEIVE_ASSISTANT_JOIN_REQUEST',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        async SEND_CASHUP_JOIN_RESPONSE(data,update = true){
            try {   
                let return_option = false 
                try {
                    const action = update?"lan_update":"lan_set" 
                    const res = await this.$store.dispatch(action,{
                        action:"JOIN_CASHUP",
                        name:"JOIN_CASHUP",
                        data:data,
                        lan:2,
                    })
                    this.CASHUP_REQUEST_DATA = res?.data
                    console.log(res,'res++++++********************++++++++++'); 
                    return_option = true 
                } catch (error) {
                    console.log(error,'error+++++********************+++++++++++');  
                    return_option = false
                }
                return return_option
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'SEND_CASHUP_JOIN_REQUEST',
                    page:PAGE_NAME, 
                }) 
            } 
        },
        APPROVE_ASSISTANT_JOIN_REQUEST(){
            try {  
                const data = this.CASHUP_REQUEST_DATA
                const us = this.us
                this.inputLoading = true
                const response = this.SEND_CASHUP_JOIN_RESPONSE({
                    key:data?.key,
                    join_approved_uid:us?.uid,
                }) 
                if (response) {
                    this.dialog_receive_join_assistant_request = false
                    this.inputLoading = false
                    let mbs_text = this.MBS.text.item_action_success("Assistant join request","Approving") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text+".",
                        btnYes:mbs_text.btnYes,  
                        btnNo:mbs_text.btnNo,   
                    }) 
                } else {
                    this.inputLoading = false
                    let mbs_text = this.MBS.text.item_action_fail("Assistant join request","Approving") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text+".",
                        btnYes:mbs_text.btnYes,  
                        btnNo:mbs_text.btnNo,   
                    })  
                    
                }
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'APPROVE_ASSISTANT_JOIN_REQUEST',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        REJECT_ASSISTANT_JOIN_REQUEST(){
            try {  
                const data = this.CASHUP_REQUEST_DATA
                const us = this.us
                this.inputLoading = true
                const response = this.SEND_CASHUP_JOIN_RESPONSE({
                    key:data?.key,
                    join_rejected_uid:us?.uid,
                }) 
                if (response) {
                    this.dialog_receive_join_assistant_request = false
                    let mbs_text = this.MBS.text.item_action_success("Assistant join request","rejecting") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text+".",
                        btnYes:mbs_text.btnYes,  
                        btnNo:mbs_text.btnNo,   
                    }) 
                } else {
                    let mbs_text = this.MBS.text.item_action_fail("Assistant join request","rejecting") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text+".",
                        btnYes:mbs_text.btnYes,  
                        btnNo:mbs_text.btnNo,   
                    })   
                }
                this.inputLoading = false
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'REJECT_ASSISTANT_JOIN_REQUEST',
                    page:PAGE_NAME, 
                })
            }  
        },
        LAN_GET_ITEM_ORDERS(){
            try {  
                const cashup = this.LocalCashup
                const key = cashup?.key 
                const cashier_cashup_key = cashup?.cashier_cashup_key 
                const day_shift_key = this.toNumber(cashup?.day_shift_key )
                const cashup_key = cashier_cashup_key?cashier_cashup_key:key

                // console.log(day_shift_key,'day_shift_key-----++--');
                
                if (cashup_key) {
                    this.$store.dispatch("lan_get",{
                        action:"LAN_ITEM_ORDERS",
                        name:"ITEM_ORDERS",
                        data:{
                            action:"find",
                            field:"day_shift_key",
                            value:""+day_shift_key,
                        },
                        lan:2,
                    }).then(res=>{
                        console.log(res,'LAN_GET_ITEM_ORDERS res--------------'); 
                        console.log(day_shift_key,'day_shift_key----***--');
                    }).catch(error=>{
                        console.log(error,'LAN_GET_ITEM_ORDERS error--------------'); 
                    })   
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'LAN_GET_ITEM_ORDERS',
                    page:PAGE_NAME, 
                })
            }  
        },  
        ON_VIEW_CASHUP(){
            try {  
                let mbs_text = this.MBS.text.item_action("Cashup details.","View")
                this.MBS.actions.dialogConfirmPassword({
                    show:true,
                    fixed:true,
                    icon:"mdi-shield-lock-outline",
                    title:"VIEW CASHUP DETAILS",
                    text:mbs_text.text+" Enter your password to confirm.",
                    action:{
                        code:PAGE_NAME+'=VIEW-CASHUP-DETAILS',
                        phone_number_start:true,
                        all_users:true, 
                        get_access:{
                            permission_type:"option",  
                            action_name:"View Cashup Details"  
                        }
                    }
                }) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_VIEW_CASHUP',
                    page:PAGE_NAME, 
                })
            }  
        }, 
        VIEW_CASHUP(){
            try {  
                this.menuSelect = !this.menuSelect
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'VIEW_CASHUP',
                    page:PAGE_NAME, 
                })
            }  
        }, 


        //-------------[main]
        async DIALOG_YES(action){ 
            try {
                if (action.code) {
                    if (action.code ===PAGE_NAME+'=CONFIRM-SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                this.input.check = true 
                                this.MBS.actions.dialogInput({
                                    show:true,
                                    fixed:true,
                                    title:"CONFIRM",
                                    text:"Enter your password to confirm switching to "+this.MBS.actions.TEXT_UP(action.data.company_name)+".",
                                    btnYes:"CONFIRM",
                                    field:[
                                        {field:"password",label:'Password',type:'password'}
                                    ],
                                    action:{
                                        ...action,
                                        code:PAGE_NAME+"=SELECT-COMPANY",
                                    }
                                })  
                            }, this.MBS.data.ACTION_REFRESH_TIME); 
                        } else {
                            
                        }  
                    } 
                    if (action.code ===PAGE_NAME+'=SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                let password = action.password
                                password = password?this.MBS.crypt.encrypt(password):null 
                                if (!password) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                }else if (password!==this.ud.p_uid) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                } else {
                                    this.SELECT_COMPANY(action.data) 
                                }   
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        } else {
                            
                        }
                    }  
                    if (action.code ===PAGE_NAME+'=CONFIRM-CLOSE-REGISTER') {
                        if (action.YES) {
                            setTimeout(() => {   
                                this.CONFIRM_BEFORE_CLOSING(action)
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        } else { 
                            setTimeout(() => {   
                                this.CONFIRM_FORCE_CLOSING_REGISTER()
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        }     
                    } 
                    if (action.code ===PAGE_NAME+'=HAVE-OPEN-ORDERS') {
                        if (action.YES) {
                            setTimeout(() => {  
                                this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/sale",true))
                                setTimeout(() => {
                                    this.MBS.events.$emit("ON_VIEW_ORDERS","view_orders_list")   
                                }, 1000);
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        } else { 
                            setTimeout(() => {   
                                this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/sale",true))
                                setTimeout(() => {
                                    this.MBS.events.$emit("ON_VIEW_ORDERS","view_orders_list")   
                                }, 1000);
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        }     
                    } 
                    if (action.code ===PAGE_NAME+'=CLOSE-REGISTER') {
                        if (action.YES) {
                            this.CLOSE_REGISTER(action.data)
                        } else { 
                        }
                    }if (action.code ===PAGE_NAME+'=ASK-TO-CLOSE-REGISTER') {
                        if (action.YES) {
                            this.ON_CLOSE_REGISTER(action.data)
                            this.DELETE_COMPANY_QUICK_ACTION(action.data)
                        } else { 
                        }
                    }
                    if (action.code ===PAGE_NAME+'=FORCE-CLOSE-REGISTER') {
                        if (action.YES) {
                            await this.FORCE_CLOSING_REGISTER(action.data)  
                        } else { 
                        }
                    }
                    if (action.code ===PAGE_NAME+'=CLOSE-CASHUP') {
                        if (action.YES) {
                            this.UPLOAD_SALES(action.data)
                        } else {
                            // this.SUBMIT_CLOSE_CASHUP(action.data) 
                        }
                    } 
                    if (action.code ===PAGE_NAME+'=VIEW-CASHUP-DETAILS') {
                        if (action.YES) {
                            this.VIEW_CASHUP()
                        } else { 
                        }
                    }
                    if (action.code ===PAGE_NAME+'=SYNC-TERMINAL') {
                        if (action.YES) { 
                            this.GET_LATEST_CONFIGURATION({till:this.CurrentTill})
                            this.SYNC_EIS_PRODUCTS({till:this.CurrentTill})
                        } else { 
                        }
                    }   
                    if (action.code ===PAGE_NAME+'=PING-SERVER') {
                        if (action.YES) { 
                            this.PING_SERVER({till:this.CurrentTill}) 
                        } else { 
                        }
                    }   
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'DIALOG_YES',
                    page:PAGE_NAME, 
                }) 
            }  
        },
        ON_LAN(value){ 
            try {
                console.log(value,'value..... ');
                    
                const {response,data,category,action} = value 
                const return_data = data?.data
                const is_array = Array.isArray(return_data)
                const name = response?.Name
                 console.log(name,'name..... ');
                    console.log(return_data,'return_data..... ');
                if (name=="JOIN_CASHUP") {
                    this.RECEIVE_ASSISTANT_JOIN_REQUEST({data:return_data,is_array,action})
                } 
                //-------ON CREATE
                if (action == "create") {
                    if (name=="ITEM_ORDERS") {
                        this.LAN_GET_ITEM_ORDERS(value)
                    } 
                }
                
                //-------ON UPDATE
                if (action == "update") {
                    if (name=="ITEM_ORDERS") {
                        this.LAN_GET_ITEM_ORDERS(value)
                    } 
                }
                // if (lan_type == "LAN2") {
                //     if (lan_event =="message") {
                //     }
                  
                    
                // }
                
                    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_LAN',
                    page:PAGE_NAME,  
                })   
            }
        },
    },
    beforeDestroy(){
        this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        this.MBS.events.$off('ON_LAN', this.ON_LAN);    
        this.MBS.events.$off('GET_LATEST_CONFIGURATION', this.GET_LATEST_CONFIGURATION);    
        this.MBS.events.$off('PING_SERVER', this.PING_SERVER);    
        this.MBS.events.$off('SYNC_EIS_PRODUCTS', this.SYNC_EIS_PRODUCTS);    
        this.MBS.events.$off('EIS_CHECK_BLOCK_STATUS', this.EIS_CHECK_BLOCK_STATUS);    
        // this.MBS.events.$off('ON_CLOSE_REGISTER', this.ON_CLOSE_REGISTER); 
        // console.log('action closed--------------ii-- ');   
    },
    watch:{ 
        CurrentTill(value){
            this.INITIATE_LOCAL_SERVER(value)
            
        }
        
    }
}
</script> 